import { useEffect } from 'react';
import { supabase } from '@/shared/config/supabase';
import { useCelebration } from './useCelebration';

/**
 * Subscribes to real-time StudentAchievements and Certificates inserts
 * for the current user. Triggers a celebration animation when a new
 * achievement is granted or a certificate is issued.
 */
export function useAchievementRealtime(studentId: string | undefined) {
  const { celebrateAchievement } = useCelebration();

  useEffect(() => {
    if (!studentId) return;

    const channel = supabase
      .channel('achievement-celebrations')
      .on(
        'postgres_changes',
        {
          event: 'INSERT',
          schema: 'public',
          table: 'StudentAchievements',
          filter: `student_id=eq.${studentId}`,
        },
        (payload) => {
          const achievement = payload.new as {
            title: string;
            emoji: string;
            description: string;
          };
          celebrateAchievement(
            `${achievement.emoji} ${achievement.title}`
          );
        }
      )
      .on(
        'postgres_changes',
        {
          event: 'INSERT',
          schema: 'public',
          table: 'Certificates',
          filter: `student_id=eq.${studentId}`,
        },
        (payload) => {
          const cert = payload.new as {
            course_name: string;
            status: string;
          };
          if (cert.status === 'ISSUED') {
            celebrateAchievement(
              `🎓 Certificado: ${cert.course_name}`
            );
          }
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [studentId, celebrateAchievement]);
}
